
    var riot = require('riot')
    
riot.tag2('profile', '<yield></yield> <div if="{!opts.uid &amp;&amp; !opts.aid}"> <h2>Sorry</h2> <p>Artist profile not found</p> </div> <div if="{opts.uid || opts.aid}"> <div class="profile-wrapper"> <div if="{isadmin || userid == artistid}" class="pull-right"> <div if="{editing}" class="row"> <div class="col-xs-12 text-right"> <button onclick="{previewProfile}" class="btn btn-primary">Preview profile</button> <button onclick="{handleSaveProfile}" class="btn btn-primary">{savebuttontext}</button> </div> <div class="col-xs-12"> <p if="{alert.message}" class="alert-{alert.style}">{alert.message}</p> </div> </div> <div if="{preview}" class="row"> <div class="col-xs-12 text-right"><a href="/members/my_profile/" if="{userid == artistid}" class="btn btn-default">Edit personal details</a> <button onclick="{editProfile}" class="btn btn-primary">Edit profile</button> </div> </div> </div> <h2>{user.first_name} {user.surname}</h2> <hr class="hrleft"> <div if="{isadmin}" class="admin-notice-float"> <div if="{user.active}" class="alert-success admin-notice text-center"> <p>This user is activated</p> <confirm onconfirm="{deactivate}" confirmtext="Deactivate" class="btn btn-default adminbutton">Deactivate user</confirm> </div> <div if="{!user.active}" class="alert-danger admin-notice text-center"> <p>This user is not activated</p> <confirm onconfirm="{activate}" confirmtext="Activate" class="btn btn-default adminbutton">Activate user</confirm> </div> <div if="{user.active}"> <div if="{user.public!=1}" class="alert-danger admin-notice text-center"> <p>This profile is not published</p> <confirm onconfirm="{publish}" confirmtext="Publish" class="btn btn-default">Publish profile</confirm> </div> <div if="{user.public==1}" class="alert-success admin-notice text-center"> <p>This profile is published</p> <confirm onconfirm="{unpublish}" confirmtext="Unpublish" class="btn btn-default">Unpublish profile</confirm> </div> </div> </div> <div show="{!editing}" if="{userId}"> <div class="samples"> <div class="featured"><a href="/images/user-images/user{userId}-profile1.jpg?w=1200" class="lightbox"> <div class="ratio"></div> <div id="lbimg1" riot-style="background-image:url(\'/images/user-images/user{userId}-profile1.jpg\');" class="img"></div><i class="fa fa-expand"></i></a></div> <div class="row thumbnails"> <div class="col-xs-12 col-md-3 tnimg"><a href="/images/user-images/user{userId}-profile2.jpg?w=1200" class="lightbox"> <div class="ratio"></div> <div id="lbimg2" riot-style="background-image:url(\'/images/user-images/user{userId}-profile2.jpg\');" class="img"></div></a></div> <div class="col-xs-12 col-md-3 tnimg"><a href="/images/user-images/user{userId}-profile3.jpg?w=1200" class="lightbox"> <div class="ratio"></div> <div id="lbimg3" riot-style="background-image:url(\'/images/user-images/user{userId}-profile3.jpg\');" class="img"></div></a></div> <div class="col-xs-12 col-md-3 tnimg"><a href="/images/user-images/user{userId}-profile4.jpg?w=1200" class="lightbox"> <div class="ratio"></div> <div id="lbimg4" riot-style="background-image:url(\'/images/user-images/user{userId}-profile4.jpg\');" class="img"></div></a></div> <div class="col-xs-12 col-md-3 tnimg"><a href="/images/user-images/user{userId}-profile5.jpg?w=1200" class="lightbox"> <div class="ratio"></div> <div id="lbimg5" riot-style="background-image:url(\'/images/user-images/user{userId}-profile5.jpg\');" class="img"></div></a></div> </div> </div> </div> <div show="{editing}" class="row"> <div class="col-xs-12"> <div class="alert-info images-info"><strong>Upload your sample images (max. file size 1MB)</strong></div> </div> <div class="col-xs-12 col-md-20 text-center"> <h4>Sample image 1</h4> <uploadimage on-click="{uploadimage}" data-ref="1"><img onerror="{parent.imgerr.bind(this,this)}" name="profileimg1" riot-src="/images/user-images/user{parent.userId}-profile1.jpg?u={parent.cachebuster}" class="img-thumbnail img-responsive"></uploadimage><br> <h5>(featured)</h5> <h5 if="{uploading[1]}">Updating <div class="fa fa-refresh fa-spin"></div> </h5> </div> <div class="col-xs-12 col-md-20 text-center"> <h4>Sample image 2</h4> <uploadimage on-click="{uploadimage}" data-ref="2"><img onerror="{parent.imgerr.bind(this,this)}" name="profileimg2" riot-src="/images/user-images/user{parent.userId}-profile2.jpg?u={parent.cachebuster}" class="img-thumbnail img-responsive"></uploadimage> <h5 if="{uploading[2]}">Updating <div if="{uploading[2]}" class="fa fa-refresh fa-spin"></div> </h5> </div> <div class="col-xs-12 col-md-20 text-center"> <h4>Sample image 3</h4> <uploadimage on-click="{uploadimage}" data-ref="3"><img onerror="{parent.imgerr.bind(this,this)}" name="profileimg3" riot-src="/images/user-images/user{parent.userId}-profile3.jpg?u={parent.cachebuster}" class="img-thumbnail img-responsive"></uploadimage> <h5 if="{uploading[3]}">Updating <div if="{uploading[3]}" class="fa fa-refresh fa-spin"></div> </h5> </div> <div class="col-xs-12 col-md-20 text-center"> <h4>Sample image 4</h4> <uploadimage on-click="{uploadimage}" data-ref="4"><img onerror="{parent.imgerr.bind(this,this)}" name="profileimg4" riot-src="/images/user-images/user{parent.userId}-profile4.jpg?u={parent.cachebuster}" class="img-thumbnail img-responsive"></uploadimage> <h5 if="{uploading[4]}">Updating <div if="{uploading[4]}" class="fa fa-refresh fa-spin"></div> </h5> </div> <div class="col-xs-12 col-md-20 text-center"> <h4>Sample image 5</h4> <uploadimage on-click="{uploadimage}" data-ref="5"><img onerror="{parent.imgerr.bind(this,this)}" name="profileimg5" riot-src="/images/user-images/user{parent.userId}-profile5.jpg?u={parent.cachebuster}" class="img-thumbnail img-responsive"></uploadimage> <h5 if="{uploading[5]}">Updating <div if="{uploading[5]}" class="fa fa-refresh fa-spin"></div> </h5> </div> <div show="{imgerror}" class="col-xs-12"> <div class="alert-danger">Error uploding your image. Please try again. Note: images must be less than 1MB in size.</div> </div> </div> <div class="maincontent"> <div class="grid"> <div class="grid-col"> <div class="grid-item"> <h3> <u>Artist Bio</u> </h3> <pre if="{!editing}">{user.bio}<span if="{!user.bio}">This artist has not completed a biography yet.</span></pre> <div if="{editing}" class="row"> <formtextarea name="bio" label="" onupdate="{handleUpdate}" value="{user.bio}" width1="0" width2="12" rows="10"></formtextarea> </div> </div> <div class="grid-item"> <h3> <u>Skills &amp; Specialities</u> </h3> <p class="title"><strong>Specialist subjects:</strong></p> <p if="{!editing}">{sastring}<span if="{!sastring}">None</span></p> <div if="{editing}"> <div each="{val,index in subjectareas}"> <input type="checkbox" onchange="{updateSubjects}" data-opt="{val}" __checked="{index &gt; 0}" id="{\'cbx_\'+val}"> <label for="{\'cbx_\'+val}">{val}</label> </div> </div><br> <p class="title"><strong>Specialist business:</strong></p> <p if="{!editing}">{bustring}<span if="{!bustring}">None</span></p> <div if="{editing}"> <div each="{val,index in businessareas}"> <input type="checkbox" onchange="{updateBusiness}" data-opt="{val}" __checked="{index &gt; 0}" id="{\'cbx_\'+val}"> <label for="{\'cbx_\'+val}">{val}</label> </div> </div> </div> </div> <div class="grid-col"> <div class="grid-item"> <h3> <u>Contact Info</u> </h3> <div if="{editing}"> <p>Select the contact methods you would like to show on your profile</p> <div each="{val,index in public_contact}"> <input type="checkbox" onchange="{updateContacts}" data-opt="{val}" __checked="{index &gt; 0}" id="{\'cbx_\'+val}"> <label for="{\'cbx_\'+val}">{val}</label> </div> <div if="{public_contact.social}"><br> <p class="title"><strong>Your social media account URLs</strong></p> <div each="{key,val in contactdetails.social}"> <forminput name="{key}" label="&lt;i class=\'fa fa-{key}\'&gt;&lt;/i&gt;" onupdate="{handleUpdateSocial}" value="{user.social[key]}" width1="1" width2="11"></forminput> </div> </div> </div> <div if="{!editing || preview}"> <div if="{contactdetails.address}"> <p class="title"><strong>Address:</strong></p> <p> <pre>{contactdetails.address}\n{contactdetails.postcode}</pre> </p> </div> <div if="{contactdetails.email}"> <p class="title"><strong>Email:</strong></p> <p>{contactdetails.email}</p> </div> <div if="{contactdetails.website}"> <p class="title"><strong>Website:</strong></p> <p>{contactdetails.website}</p> </div> <div if="{contactdetails.phone1}"> <p class="title"><strong>Phone:</strong></p> <p>{contactdetails.phone1}</p> </div> <div if="{contactdetails.social}"> <p class="title"><strong>Social</strong></p><a each="{key,val in contactdetails.social}" if="{user.social[key]}" href="{user.social[key]}" target="_blank" class="social-circle social-{key}"><span class="fa-stack fa-lg"><i class="fa fa-circle fa-stack-2x"></i><i if="{key!=\'youtube\'}" class="fa fa-stack-1x fa-inverse fa-{key}"></i><i if="{key==\'youtube\'}" class="fa fa-stack-1x fa-inverse fa-{key}-play"></i></span></a> </div> </div> </div> <div class="grid-item"> <h3> <u>Tags</u> </h3> <div show="{editing}"> <tags_input user_id="{artistid}"></tags_input> </div> <div show="{!editing}"> <tags_output user_id="{artistid}"></tags_output> </div> </div> </div> </div> </div> <div if="{isadmin || userid == artistid}"> <div if="{editing}" class="row"> <div class="col-xs-12 text-right"> <button onclick="{previewProfile}" class="btn btn-primary">Preview profile</button> <button onclick="{handleSaveProfile}" class="btn btn-primary">{savebuttontext}</button> </div> <div class="col-xs-12"> <p if="{alert.message}" class="alert-{alert.style}">{alert.message}</p> </div> </div> <div if="{preview}" class="row"> <div class="col-xs-12 text-right"><a href="/members/my_profile/" if="{userid == artistid}" class="btn btn-default">Edit personal details</a> <button onclick="{editProfile}" class="btn btn-primary">Edit profile</button> </div> </div> </div> <div if="{isadmin &amp;&amp; user.active}" class="row"> <div class="col-xs-12 text-right"> <div class="row"> <div style="position:relative;display:inline-block;" class="admin-notice-float"><br> <div if="{user.public!=1}" class="alert-danger admin-notice text-center"> <p>This profile is not published</p> <button onclick="{publish}" class="btn btn-default adminbutton">Publish this profile</button> </div> <div if="{user.public==1}" class="alert-success admin-notice text-center"> <p>This profile is published</p> <button onclick="{unpublish}" class="btn btn-default adminbutton">Unpublish this profile</button> </div> </div> </div> </div> </div> </div> </div>', '.images-info { padding: 15px; outline: 1px solid rgba(0,0,0,0.1); margin-bottom: 15px; } .admin-notice-float { position: fixed; top: 120px; right: 15px; z-index: 1000; } .admin-notice-float .admin-notice { padding: 15px; outline: 1px solid rgba(0,0,0,0.2); } .admin-notice-float .admin-notice p { padding: 0; margin: 0; } .admin-notice-float .admin-notice button { margin-top: 10px; } @media (max-width: 991px) { .admin-notice-float .admin-notice br { display: none; } .admin-notice-float .admin-notice button { margin-left: 10px; margin-top: 0; } } @media (max-width: 991px) { .admin-notice-float { position: relative; top: auto; right: auto; } } .profile-wrapper { position: relative; } .profile-wrapper .maincontent { margin: 0 -15px; } .profile-wrapper .maincontent .grid { max-width: 100%; margin: 0 auto; display: grid; grid-template-columns: 50% 50%; } .profile-wrapper .maincontent .grid.grid-full { grid-template-columns: 100%; } .profile-wrapper .maincontent .grid .grid-col { display: grid; margin: 0 15px; } .profile-wrapper .maincontent .grid .grid-col .grid-item { padding: 30px; background: #fff; margin: 15px 0; -webkit-box-shadow: 0 25px 50px rgba(0,0,0,0.1); box-shadow: 0 25px 50px rgba(0,0,0,0.1); } .profile-wrapper .maincontent .grid .grid-col .grid-item h3 u { position: relative; display: block; } .profile-wrapper .maincontent .grid .grid-col .grid-item h3 u:after { position: relative; } .profile-wrapper .maincontent .grid .grid-col .grid-item h3 u:before { display: block; content: ""; width: 100%; height: 3px; background: #efefef; position: absolute; bottom: 0; } .profile-wrapper .maincontent .grid .grid-col .grid-item h3 span { color: #fc2d21; } .profile-wrapper .maincontent .grid .grid-col .grid-item pre { white-space: pre-line; word-break: normal; word-wrap: normal; border: 0px solid transparent; background: transparent; font-family: inherit; font-size: inherit; padding: 0; margin: 0; } .profile-wrapper .maincontent .grid .grid-col .grid-item p.title { color: #fc2d21; padding: 0; margin: 0; } @media (max-width: 991px) { .profile-wrapper .maincontent .grid { display: block; max-width: 100%; } .profile-wrapper .maincontent .grid .grid-col { display: block; } }', '', function(opts) {
var LuminousGallery, contactApi, profileApi, resource, selfApi, userApi;

LuminousGallery = require('luminous-lightbox').LuminousGallery;

resource = require('riot-kit/utils/apiResource.coffee');

userApi = new resource('/duocms/api/artists', true);

profileApi = new resource('/duocms/api/users', true);

selfApi = new resource('/duocms/api/users/me', true);

contactApi = new resource('/duocms/api/contacts', true);

this.lg = false;

this.userid = this.opts.uid || null;

this.artistid = this.opts.aid || this.userid || null;

this.uploading = ["", false, false, false, false, false];

this.imgerror = false;

this.isadmin = this.opts.isadmin || false;

this.loggedin = null;

this.savebuttontext = "Save artist profile";

this.alert = {
  message: false,
  style: false
};

this.editing = false;

this.preview = false;

if (this.userid === this.artistid) {
  this.loggedin = 1;
  this.unpub = 1;
  this.preview = true;
}

if (this.isadmin) {
  this.preview = true;
  this.unpub = 1;
}

this.sastring = "";

this.bustring = "";

this.public_contact = {};

this.contactdetails = {};

this.social = {};

this.socialdefaults = {
  facebook: "",
  twitter: "",
  linkedin: "",
  instagram: "",
  youtube: "",
  pinterest: ""
};

this.contactopts = {
  address: 0,
  email: 0,
  website: 0,
  phone: 0,
  social: 0
};

this.subjopts = {
  "3D modelling and rendering": 0,
  "3D models": "3D models",
  "anatomy and pathology": 0,
  "animations": 0,
  "biology and histology": 0,
  "clinical and diagnostic imaging": 0,
  "graphic design and publishing": 0,
  "infographics": 0,
  "legal and forensic": 0,
  "plastic and reconstruction": 0,
  "sculpture and installations": 0,
  "sport and physiotherapy": 0,
  "surgical steps": 0,
  "traditional painting": 0,
  "video and multimedia": 0
};

this.busopts = {
  "Advertising": 0,
  "Art & Exhibitions": 0,
  "Biotechnology": 0,
  "Marketing & Communications": 0,
  "Medical devices": 0,
  "Medical education": 0,
  "Pharmaceutical": 0,
  "Publishing": 0,
  "Teaching": 0
};

this.on('mount', function() {
  if (this.artistid) {
    return userApi.get({
      id: this.artistid,
      loggedin: this.unpub
    }, (function(_this) {
      return function(data) {
        if ((data != null ? data.id : void 0) != null) {
          _this.userId = data.id;
          _this.user = data;
          _this.public_contact = _this.user.public_contact || _this.contactopts;
          _this.public_contact = _this.checkJson(_this.public_contact);
          _this.subjectareas = _this.checkJson(_this.user.subjectareas) || _this.subjopts;
          _this.businessareas = _this.checkJson(_this.user.businessareas) || _this.busopts;
          _this.setSpecialStrings();
          _this.getContactDetails();
          if (!window.location.pathname.match(/\/cms\//) && !_this.lg) {
            _this.lg = new LuminousGallery(document.querySelectorAll(".lightbox"), {
              injectBaseStyles: true,
              showCloseButton: true,
              includeImgixJSClass: true
            });
          }
          return _this.update();
        }
      };
    })(this));
  }
});

this.imgerr = function(tag, err) {
  var imgname;
  imgname = "profileimg" + tag.opts.dataRef.toString();
  return tag[imgname].src = "/images/user-images/profile-blank.png";
};

this.updatesocial = (function(_this) {
  return function(e) {
    _this.social[e.srcElement.name] = e.srcElement.value;
    return _this.update();
  };
})(this);

this.publish = (function(_this) {
  return function() {
    _this.user["public"] = 1;
    return _this.handleSaveProfile();
  };
})(this);

this.unpublish = (function(_this) {
  return function() {
    _this.user["public"] = 0;
    return _this.handleSaveProfile();
  };
})(this);

this.activate = (function(_this) {
  return function() {
    if (_this.user.group_ids.indexOf(9) < 0) {
      _this.user.group_ids.push(9);
      _this.user.active = 1;
    }
    return _this.handleSaveProfile();
  };
})(this);

this.deactivate = (function(_this) {
  return function() {
    if (_this.user.group_ids.indexOf(9) > -1) {
      _this.user.group_ids.splice(_this.user.group_ids.indexOf(9), 1);
      _this.user.active = null;
    }
    return _this.handleSaveProfile();
  };
})(this);

this.previewProfile = (function(_this) {
  return function() {
    _this.editing = false;
    _this.preview = true;
    return _this.update();
  };
})(this);

this.editProfile = (function(_this) {
  return function() {
    _this.editing = true;
    _this.preview = false;
    return _this.update();
  };
})(this);

this.getContactDetails = (function(_this) {
  return function() {
    var attr;
    attr = [];
    Object.keys(_this.public_contact).forEach(function(key) {
      var newkey;
      newkey = key;
      if (key === "phone") {
        newkey = "phone1";
      }
      if (_this.public_contact[key] > 0) {
        return attr.push(newkey);
      }
    });
    return contactApi.get({
      id: _this.user.id,
      attributes: attr
    }, function(data) {
      if (data) {
        _this.contactdetails = data;
        if (_this.contactdetails.phone1) {
          _this.contactdetails.phone = _this.contactdetails.phone1;
        }
        if (_this.public_contact.social) {
          if (!_this.contactdetails.social || (typeof _this.contactdetails.social === "string" && _this.contactdetails.social.length === 0)) {
            _this.contactdetails.social = _this.socialdefaults;
            _this.user.social = _this.contactdetails.social;
          }
          _this.contactdetails.social = _this.checkJson(_this.contactdetails.social);
          if (!_this.contactdetails.social.hasOwnProperty("facebook")) {
            _this.contactdetails.social = _this.socialdefaults;
          }
          _this.user.social = _this.contactdetails.social;
        }
        return _this.update();
      }
    });
  };
})(this);

this.setSpecialStrings = (function(_this) {
  return function() {
    _this.sastring = "";
    _this.bustring = "";
    Object.keys(_this.subjectareas).forEach(function(key) {
      if (_this.subjectareas[key] > 0) {
        return _this.sastring += key + ", ";
      }
    });
    if (_this.sastring.length > 0) {
      _this.sastring = _this.sastring.replace(/,(?=[^,]*$)/, '');
    }
    Object.keys(_this.businessareas).forEach(function(key) {
      if (_this.businessareas[key] > 0) {
        return _this.bustring += key + ", ";
      }
    });
    if (_this.bustring.length > 0) {
      return _this.bustring = _this.bustring.replace(/,(?=[^,]*$)/, '');
    }
  };
})(this);

this.checkJson = (function(_this) {
  return function(obj) {
    if (obj !== null && (obj.constructor !== {}.constructor)) {
      obj = JSON.parse(obj);
    }
    return obj;
  };
})(this);

this.updateContacts = (function(_this) {
  return function(e) {
    _this.public_contact[e.srcElement.dataset.opt] = +e.srcElement.checked;
    _this.getContactDetails();
    return _this.update();
  };
})(this);

this.updateSubjects = (function(_this) {
  return function(e) {
    _this.subjectareas[e.srcElement.dataset.opt] = +e.srcElement.checked;
    _this.setSpecialStrings();
    return _this.update();
  };
})(this);

this.updateBusiness = (function(_this) {
  return function(e) {
    _this.businessareas[e.srcElement.dataset.opt] = +e.srcElement.checked;
    _this.setSpecialStrings();
    return _this.update();
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleUpdateSocial = (function(_this) {
  return function(update) {
    _this.user.social[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleSaveProfile = (function(_this) {
  return function() {
    var saveapi;
    if (_this.loggedin) {
      delete _this.user.id;
      saveapi = selfApi;
    } else {
      saveapi = profileApi;
    }
    _this.user.public_contact = JSON.stringify(_this.public_contact);
    _this.user.subjectareas = JSON.stringify(_this.subjectareas);
    _this.user.businessareas = JSON.stringify(_this.businessareas);
    _this.user.social = JSON.stringify(_this.contactdetails.social);
    saveapi.save(_this.user, function(data, msg) {
      if (data.id) {
        _this.editing = false;
        _this.preview = true;
        _this.user.public_contact = JSON.parse(_this.user.public_contact) || _this.contactopts;
        if (_this.user.social) {
          _this.user.social = JSON.parse(_this.user.social) || _this.socialdefaults;
        }
      }
      return _this.update();
    });
    return _this.update();
  };
})(this);

this.cachebuster = "";

this.uploadimage = (function(_this) {
  return function(file, e) {
    var filename, formData, imgint, root, self, uid, upl, uploaderr, xhr;
    if (parseInt(e.srcElement.parentNode.dataset.ref) > 0) {
      imgint = e.srcElement.parentNode.dataset.ref;
      _this.uploading[parseInt(imgint)] = true;
      _this.update();
      filename = "user" + _this.userId + "-profile" + e.srcElement.parentNode.dataset.ref + ".jpg";
    } else {
      filename = "user" + _this.userId + ".jpg";
    }
    uid = _this.userId;
    formData = new FormData();
    formData.append("file", file);
    formData.append("filename", filename);
    xhr = new XMLHttpRequest();
    xhr.open('POST', '/duocms/api/artists/me/upload_image?_csrf=' + window.csrf, true);
    self = _this;
    upl = _this.uploading;
    uploaderr = _this.imgerror;
    root = _this;
    xhr.onload = function(e) {
      var img, random, resp;
      try {
        resp = JSON.parse(this.response);
      } catch (error) {
        e = error;
        upl[parseInt(imgint)] = false;
        uploaderr = true;
        root.update();
        return;
      }
      self.cachebuster = +(new Date());
      self.update();
      if (resp && resp.status === "success") {
        if (imgint) {
          upl[parseInt(imgint)] = false;
          root.update();
          img = document.querySelector("#lbimg" + imgint);
          random = new Date().getTime() / 1000;
          return img.setAttribute('style', "background-image:url('/images/user-images/user" + uid + "-profile" + imgint + ".jpg?" + random + "')");
        }
      }
    };
    return xhr.send(formData);
  };
})(this);
});
riot.tag2('profile-edit', '<yield></yield> <div class="profile-wrapper"> <div class="pull-right"><a href="/artists/profile/?id={opts.uid}" class="btn btn-primary">View your artist profile <i class="fa fa-angle-right"></i></a></div> <h3>Update your profile</h3> <form class="form-horizontal"> <div class="row"> <div class="col-xs-12"> <forminput name="first_name" label="First Name" onupdate="{handleUpdate}" value="{user.first_name}" width1="4" width2="8"></forminput> <forminput name="surname" label="Surname" onupdate="{handleUpdate}" value="{user.surname}" width1="4" width2="8"></forminput> <forminput name="email" label="Email" onupdate="{handleUpdate}" value="{user.email}" width1="4" width2="8"></forminput> <forminput name="organisation" label="Company/Organisation" onupdate="{handleUpdate}" value="{user.organisation}" width1="4" width2="8"></forminput> <formtextarea name="address" label="Address" onupdate="{handleUpdate}" value="{user.address}" width1="4" width2="8"></formtextarea> <forminput name="state" label="County" onupdate="{handleUpdate}" value="{user.state}" width1="4" width2="8"></forminput> <forminput name="postcode" label="Postcode" onupdate="{handleUpdate}" value="{user.postcode}" width1="4" width2="8"></forminput> <forminput name="country" label="Country" onupdate="{handleUpdate}" value="{user.country}" width1="4" width2="8"></forminput> <forminput name="phone1" label="Telephone" onupdate="{handleUpdate}" value="{user.phone1}" width1="4" width2="8"></forminput> <forminput name="phone2" label="Mobile" onupdate="{handleUpdate}" value="{user.phone2}" width1="4" width2="8"></forminput> <div class="row"> <div class="col-xs-12 col-sm-4 pilabel"> <label>Profile image</label> </div> <div class="col-xs-12 col-sm-8"> <uploadimage on-click="{uploadimage}"><img riot-tag="img_loader" riot-src="/images/user-images/user{parent.userId}.jpg?u={parent.cachebuster}" default="/images/user-images/default.jpg" width="200" class="img-thumbnail"></uploadimage> </div> <div class="col-xs-12 text-right"> <button class="btn btn-success savetextbtn {savetext ? \'\' : \'hideme\'}">{savetext}</button> <button onclick="{handleSaveProfile}" class="btn btn-primary">Save profile</button> </div> </div> </div> </div> </form> <hr> <h3>Update your password</h3> <change-password onsuccess="/members_area/"></change-password> </div>', '.savetextbtn { -webkit-transition: opacity 0.3s ease; -moz-transition: opacity 0.3s ease; -o-transition: opacity 0.3s ease; -ms-transition: opacity 0.3s ease; transition: opacity 0.3s ease; opacity: 1; -ms-filter: none; filter: none; } .savetextbtn.hideme { opacity: 0; -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)"; filter: alpha(opacity=0); } @media (min-width: 768px) { .pilabel { text-align: right; } }', '', function(opts) {
var loginApi, logoutApi, profileApi, resource;

resource = require('riot-kit/utils/apiResource.coffee');

loginApi = new resource('/duocms/api/login', true);

logoutApi = new resource('/duocms/api/logout', true);

profileApi = new resource('/duocms/api/users/me', true);

this.savetext = null;

this.on('mount', function() {
  if (this.opts.uid) {
    console.log(this.opts.uid);
  }
  return loginApi.get((function(_this) {
    return function(data) {
      if ((data != null ? data.id : void 0) != null) {
        _this.userId = data.id;
        _this.user = data;
        return _this.update();
      }
    };
  })(this));
});

this.handleLogOut = (function(_this) {
  return function() {
    return logoutApi.get(function() {
      return _this.handleLoggedOut();
    });
  };
})(this);

this.handleLoggedOut = (function(_this) {
  return function() {
    _this.tags.profile.hide();
    return setTimeout(function() {
      return window.location.pathname = '/';
    }, 500);
  };
})(this);

this.close = (function(_this) {
  return function() {};
})(this);

this.handleUpdate = (function(_this) {
  return function(update) {
    _this.user[update.name] = update.value;
    return _this.update();
  };
})(this);

this.handleSignIn = (function(_this) {
  return function() {
    return _this.tags.signin.tags.signin.signin();
  };
})(this);

this.handleSignedIn = (function(_this) {
  return function() {
    _this.tags.signin.hide();
    return setTimeout(function() {
      return window.location.pathname = '/members_area/';
    }, 500);
  };
})(this);

this.handleSaveProfile = (function(_this) {
  return function() {
    _this.userdata = _this.user;
    delete _this.userdata.id;
    return profileApi.save(_this.userdata, function(data, err) {
      if (err) {
        console.log(err);
      }
      if (data && data.id) {
        _this.savetext = "Profile saved!";
        setTimeout(function() {
          _this.savetext = null;
          return _this.update();
        }, 3000);
      }
      return _this.update();
    });
  };
})(this);

this.cachebuster = "";

this.uploadimage = (function(_this) {
  return function(file) {
    var formData, self, xhr;
    formData = new FormData();
    formData.append("file", file);
    xhr = new XMLHttpRequest();
    xhr.open('POST', '/duocms/api/artists/me/upload_image?_csrf=' + window.csrf, true);
    self = _this;
    xhr.onload = function() {
      var resp;
      resp = JSON.parse(this.response);
      self.cachebuster = +(new Date());
      return self.update();
    };
    return xhr.send(formData);
  };
})(this);
});
    
  